export default __webpack_public_path__ + "static/media/member2.86b1402b.png";